import { render, staticRenderFns } from "./perkerasan.vue?vue&type=template&id=1416ceea&"
import script from "./perkerasan.vue?vue&type=script&lang=js&"
export * from "./perkerasan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports